import CompletedDeliveries from './CompletedDeliveries';

export default CompletedDeliveries;
